// import { toCamelCase } from 'fe-common'

export default ({ store, route, params }) => {
  store.commit('USER_TIP_CATEGORY', null)
  // todo: userTip optimization part 2
  // if (route.path.indexOf('/promotion-receive') || ...) {
  // store.commit('USER_TIP_CATEGORY', toCamelCase(params.category))
  // return store.dispatch('getUserTips', { category: route.path })
  // }
}
